
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Vector","d":"M 15.924 15.846 L 21.422 21.384 M 16.083 21.512 L 21.619 15.896 M 8.691 18.6 L 4.893 18.6 C 4.18 18.587 3.569 18.085 3.419 17.387 L 1.139 7.787 C 1.015 7.322 1.111 6.825 1.398 6.438 C 1.685 6.052 2.132 5.817 2.613 5.8 L 21.966 5.8 C 22.447 5.817 22.894 6.052 23.181 6.439 C 23.468 6.825 23.563 7.322 23.441 7.787 L 23.121 9.127 M 4.292 5.8 L 9.091 1 M 20.287 5.8 L 15.489 1.002 M 25.086 18.6 C 25.086 22.135 22.221 25 18.688 25 C 15.154 25 12.29 22.135 12.29 18.6 C 12.29 15.065 15.154 12.2 18.688 12.2 C 22.221 12.2 25.086 15.065 25.086 18.6 Z","stroke-width":"1.92","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor","transform":"matrix(1, 0, 0, 1, -2.220446049250313e-16, 0)"}})])
          )
        }
      }
    